import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const LINKS = [
  { label: "Le cycle", id: "cycle" },
  { label: "Pepe", id: "pepe" },
  { label: "Packs", id: "packs" },
  { label: "Engagements", id: "engagements" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), open ? 250 : 0);
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "glass py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 flex items-center justify-between">
        <a
          href="/"
          className="shrink-0"
          data-testid="nav-logo"
          onClick={(e) => {
            e.preventDefault();
            if (window.__lenis) window.__lenis.scrollTo(0);
            else window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              onClick={(e) => {
                e.preventDefault();
                go(l.id);
              }}
              className="text-sm text-mist hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            data-testid="nav-cta-demo"
            onClick={() => go("demo")}
            className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-iris-deep to-viol px-5 py-2.5 text-sm font-medium text-white shadow-[0_0_24px_rgba(139,92,246,0.35)] transition-all duration-300 hover:shadow-[0_0_36px_rgba(139,92,246,0.55)] hover:-translate-y-0.5"
          >
            Demander une démo
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>

        <button
          className="md:hidden text-white p-1.5"
          data-testid="nav-burger"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.22 }}
            className="md:hidden glass mx-4 mt-3 rounded-2xl p-5 flex flex-col gap-1"
          >
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  go(l.id);
                }}
                className="py-3 text-base text-white/90 border-b border-ink-line last:border-0"
              >
                {l.label}
              </a>
            ))}
            <button
              data-testid="nav-mobile-cta-demo"
              onClick={() => go("demo")}
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-iris-deep to-viol px-5 py-3 text-sm font-medium text-white"
            >
              Demander une démo
              <ArrowUpRight size={16} />
            </button>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Nav;
